export const loyaltyRoutes = [
  {
    path: '/loyalty',
    component: () => import('../../layouts/main/Main'),
    children: [
      {
        path: 'apps',
        component: () => import('./views/apps/index.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'إدارة المشاريع', active: true }
          ],
          pageTitle: 'إدارة المشاريع'
        }
      },
      {
        path: 'coupons',
        component: () => import('./views/coupons/index.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'إدارة الكوبونات', active: true }
          ],
          pageTitle: 'إدارة الكوبونات'
        }
      },
      {
        path: 'coupons/assign',
        component: () => import('./views/coupons/AssignCoupons.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'إسناد الكوبونات', active: true },
          ],
          pageTitle: 'إسناد الكوبونات'
        }
      },
      {
        path: 'clients',
        component: () => import('./views/clients/index.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'إدارة المستخدمين', active: true }
          ],
          pageTitle: 'إدارة المستخدمين'
        }
      },
      {
        path: 'clients/:id/coupons',
        component: () => import('./views/clients/coupons.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'إدارة المستخدمين', url: '/loyalty/clients' },
            { title: 'كوبونات المستخدم الحالية', active: true },
          ],
          pageTitle: 'كوبونات المستخدم الحالية'
        }
      },
      {
        path: 'tiers',
        component: () => import('./views/tiers/index.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'إدارة المستويات', active: true }
          ],
          pageTitle: 'إدارة المستويات'
        }
      },
      {
        path: 'rewards',
        component: () => import('./views/rewards/index.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'إدارة المكافآت', active: true }
          ],
          pageTitle: 'إدارة المكافآت'
        }
      },
      {
        path: 'redeem',
        component: () => import('./views/redeem/index.vue'),
        meta: {
          breadcrumb: [
            { title: 'Home', url: '/' },
            { title: 'إدارة استبدال النقاط', active: true }
          ],
          pageTitle: 'إدارة استبدال النقاط'
        }
      },
    ]
  }
];
